export const ProductGroup = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Ad Group Product Partition',
    },
    BidBoost: {
      'bulk-upload-header': 'Bid Adjustment',
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
    IsLeaf: {
      'bulk-upload-header': 'Sub Type',
    },
  },
};
